const reducer = (state="dashboard", action)=>{
   if(action.type === 'screenStates'){
        return action.value
    }

    else return state;

}

export default reducer;